/* Lift Easy Townlec — product-form.js
   Product page: description tabs, per-option variant picker, extra
   configuration dropdowns, and the request-a-quote panel.
   Vanilla JS, progressive enhancement. No external dependencies. */
(function () {
  'use strict';

  /* ---------- Description / Specifications / Shipping tabs ---------- */
  document.querySelectorAll('[data-tabs]').forEach(function (g) {
    var tabs = [].slice.call(g.querySelectorAll('[role=tab]'));
    function sel(t) {
      tabs.forEach(function (o) {
        var p = document.getElementById(o.getAttribute('aria-controls'));
        o.setAttribute('aria-selected', 'false');
        o.tabIndex = -1;
        if (p) p.hidden = true;
      });
      t.setAttribute('aria-selected', 'true');
      t.tabIndex = 0;
      var tp = document.getElementById(t.getAttribute('aria-controls'));
      if (tp) tp.hidden = false;
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { sel(t); });
      t.addEventListener('keydown', function (e) {
        var n;
        if (e.key === 'ArrowRight') n = tabs[(i + 1) % tabs.length];
        else if (e.key === 'ArrowLeft') n = tabs[(i - 1 + tabs.length) % tabs.length];
        if (n) { e.preventDefault(); n.focus(); sel(n); }
      });
    });
  });
})();

(function () {
  'use strict';

  var root = document.querySelector('[data-variant-picker]');
  var groups = root ? [].slice.call(root.querySelectorAll('.vpick__group')) : [];
  var variants = [];
  var poa = root ? root.getAttribute('data-poa') === 'true' : false;

  if (root) {
    var dataEl = root.querySelector('[data-variant-json]');
    if (dataEl) {
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { variants = []; }
    }
  }

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------- Quote summary ----------
     Rolls the native variant choices and the extra config dropdowns into one
     readable list, mirrored into a hidden field so the email spells out
     exactly what the customer built. */
  function collect() {
    var out = [];
    groups.forEach(function (g) {
      var name = g.querySelector('.vpick__name');
      var chosen = g.querySelector('.vpick__input:checked');
      if (name && chosen) out.push([name.textContent.trim(), chosen.value]);
    });
    document.querySelectorAll('[data-config-select]').forEach(function (s) {
      var l = document.querySelector('label[for="' + s.id + '"]');
      out.push([l ? l.textContent.trim() : s.name, s.value]);
    });
    return out;
  }

  function syncQuote() {
    var pairs = collect();
    var hidden = document.querySelector('[data-quote-config]');
    if (hidden) hidden.value = pairs.map(function (p) { return p[0] + ': ' + p[1]; }).join(' | ');
    var list = document.querySelector('[data-quote-summary]');
    if (list) {
      list.innerHTML = pairs.length
        ? pairs.map(function (p) { return '<li><b>' + esc(p[0]) + ':</b> ' + esc(p[1]) + '</li>'; }).join('')
        : '<li>Standard configuration</li>';
    }
  }

  /* ---------- Variant picker ---------- */
  if (root && variants.length) {
    var idInput = root.querySelector('[data-variant-id]');
    var noneMsg = root.querySelector('[data-variant-none]');
    var priceWrap = document.querySelector('.product__price');
    var gstEl = priceWrap ? priceWrap.querySelector('.price__gst') : null;
    var gstHtml = gstEl ? gstEl.outerHTML : '';
    var mainImg = document.querySelector('[data-gallery-main] img');

    var selected = function () {
      return groups.map(function (g) {
        var c = g.querySelector('.vpick__input:checked');
        return c ? c.value : null;
      });
    };

    var matches = function (trial) {
      return variants.filter(function (v) {
        for (var j = 0; j < trial.length; j++) {
          if (trial[j] !== null && v.o[j] !== trial[j]) return false;
        }
        return true;
      });
    };

    /* Mirrors the Liquid rules in main-product.liquid. product.available is NOT
       a stock check — with continue-selling on it stays true at 0 qty, so the
       quantity must be tested too, guarded by whether inventory is tracked. */
    var stateFor = function (v) {
      if (!v.a) return { cls: 'pdp-stock--out', txt: 'Special Order' };
      if (v.t && v.q <= 0) return { cls: 'pdp-stock--order', txt: 'Available to order' };
      if (v.t && v.q > 0 && v.q <= 5) return { cls: 'pdp-stock--low', txt: 'Low stock — only ' + v.q + ' left' };
      if (v.t && v.q > 0) return { cls: 'pdp-stock--in', txt: 'In stock — ' + v.q + ' available' };
      return { cls: 'pdp-stock--in', txt: 'In stock' };
    };

    /* Grey out choices that produce a combination we don't carry, and flag the
       ones that exist but aren't on the shelf. Skipped on POA products, where
       every variant is $0 / unstocked and everything would look disabled. */
    var refreshAvailability = function (sel) {
      groups.forEach(function (g, gi) {
        g.querySelectorAll('.vpick__input').forEach(function (input) {
          var label = g.querySelector('label[for="' + input.id + '"]');
          if (!label) return;
          var trial = sel.slice();
          trial[gi] = input.value;
          var found = matches(trial);
          label.removeAttribute('data-note');
          if (!found.length) {
            label.setAttribute('data-unavailable', 'true');
            return;
          }
          label.removeAttribute('data-unavailable');
          if (poa || label.parentNode.classList.contains('vpick__opt--swatch')) return;
          var anyAvailable = found.some(function (v) { return v.a; });
          var anyOnHand = found.some(function (v) { return !v.t || v.q > 0; });
          if (!anyAvailable) label.setAttribute('data-note', 'special order');
          else if (!anyOnHand) label.setAttribute('data-note', 'available to order');
        });
      });
    };

    var widthUrl = function (url, w) {
      if (!url) return url;
      return /[?&]width=\d+/.test(url)
        ? url.replace(/([?&]width=)\d+/, '$1' + w)
        : url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
    };

    /* A srcset ALWAYS beats src — any JS that swaps a Liquid image_tag image
       must rewrite srcset/sizes too, or nothing visibly changes. */
    var setMainImage = function (url) {
      if (!mainImg || !url) return;
      mainImg.setAttribute('srcset', [400, 600, 800, 1000].map(function (w) {
        return widthUrl(url, w) + ' ' + w + 'w';
      }).join(', '));
      mainImg.setAttribute('sizes', '(min-width:768px) 48vw, 100vw');
      mainImg.setAttribute('src', url);
      mainImg.removeAttribute('width');
      mainImg.removeAttribute('height');
      mainImg.removeAttribute('loading');
    };

    var update = function () {
      var sel = selected();
      groups.forEach(function (g, gi) {
        var out = root.querySelector('[data-chosen-for="' + gi + '"]');
        if (out) out.textContent = sel[gi] || '';
      });
      refreshAvailability(sel);

      var found = matches(sel);
      var v = (found.length && sel.indexOf(null) === -1) ? found[0] : null;
      if (noneMsg) noneMsg.hidden = !!v;

      if (v) {
        if (idInput) idInput.value = v.id;

        if (priceWrap && !poa) {
          if (v.p === 0) {
            priceWrap.innerHTML = '<span class="price price--poa" title="Price on application">POA</span>';
          } else if (v.cf) {
            priceWrap.innerHTML = '<span class="price price--on-sale"><s class="price__regular">' + esc(v.cf) + '</s> <span class="price__sale">' + esc(v.pf) + '</span> ' + gstHtml + '</span>';
          } else {
            priceWrap.innerHTML = '<span class="price">' + esc(v.pf) + ' ' + gstHtml + '</span>';
          }
        }

        var skuEl = document.querySelector('.product__sku');
        if (skuEl && v.sku) skuEl.textContent = skuEl.textContent.split(':')[0] + ': ' + v.sku;
        var skuCell = document.querySelector('[data-spec-sku]');
        if (skuCell && v.sku) skuCell.textContent = v.sku;

        var stock = document.querySelector('.pdp-stock');
        if (stock && !poa) {
          var st = stateFor(v);
          stock.className = 'pdp-stock ' + st.cls;
          var txt = stock.querySelector('span:last-child');
          if (txt) txt.textContent = st.txt;
        }

        var buy = document.querySelector('.product__form button[type="submit"]');
        if (buy && !poa) {
          buy.disabled = !v.a;
          buy.textContent = v.a ? buy.getAttribute('data-add-label') : buy.getAttribute('data-sold-label');
        }

        if (v.img) setMainImage(v.img);

        if (window.history && window.history.replaceState) {
          try {
            var u = new URL(window.location.href);
            u.searchParams.set('variant', v.id);
            window.history.replaceState({}, '', u.toString());
          } catch (e) {}
        }
      }
      syncQuote();
    };

    root.addEventListener('change', function (e) {
      if (e.target && e.target.classList.contains('vpick__input')) update();
    });
    update();
  }

  /* ---------- Extra config dropdowns ---------- */
  document.querySelectorAll('[data-config-select]').forEach(function (s) {
    s.addEventListener('change', syncQuote);
  });

  /* ---------- Request-a-quote panel ---------- */
  var toggle = document.querySelector('[data-quote-toggle]');
  var panel = document.getElementById('QuotePanel');
  if (toggle && panel) {
    toggle.addEventListener('click', function () {
      var open = panel.hidden;
      panel.hidden = !open;
      toggle.setAttribute('aria-expanded', String(open));
      if (open) {
        syncQuote();
        var first = panel.querySelector('input, textarea');
        if (first) first.focus();
      }
    });
    /* Shopify reloads the page after a contact-form post — reopen the panel so
       the shopper sees the confirmation or the validation errors. */
    if (panel.querySelector('.pquote__ok, .pquote__err')) {
      panel.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
      panel.scrollIntoView({ block: 'center' });
    }
  }

  syncQuote();
})();
